import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/module/angular-material/angular-material.module';
import { ReadOnlyDirective } from 'src/app/module/order/directive/read-only.directive';
import { ConfirmDialogComponent, ConfirmDialogConfig } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-ordered-list',
  templateUrl: './ordered-list.component.html',
  styleUrls: ['./ordered-list.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularMaterialModule, FormsModule, ReactiveFormsModule, ReadOnlyDirective],
})
export class OrderedListComponent {
  reConcileStep: any = {
    recValue: '',
    recLabel: 'add',
    recIndex: 0,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private _matDialog: MatDialog,
    public dialogRef: MatDialogRef<OrderedListComponent>
  ) {}

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.dialogData.field.template, event.previousIndex, event.currentIndex);
    this.onSet();
  }

  onDelete(index: number) {
    this.dialogData.field.template.splice(index, 1);
    this.pathControlValue(this.dialogData.field.template);
  }

  onEdit(index: number) {
    this.reConcileStep.recValue = this.dialogData.field.template[index] || '';
    this.reConcileStep.recLabel = 'update';
    this.reConcileStep.recIndex = index;
  }

  onCancel() {
    this.reConcileStep = {
      recValue: '',
      recLabel: 'add',
      recIndex: 0,
    };
  }

  onAddOrUpdate() {
    if (this.reConcileStep.recLabel == 'add') {
      this.dialogData.field.template.push(this.reConcileStep.recValue);
      this.pathControlValue(this.dialogData.field.template);
    } else {
      this.dialogData.field.template[this.reConcileStep.recIndex] = this.reConcileStep.recValue;
      this.pathControlValue(this.dialogData.field.template);
    }
    this.onCancel();
  }

  pathControlValue(value: any) {
    this.dialogData.fg.patchValue({
      [this.dialogData.field.name]: value,
    });
  }

  close() {
    this.dialogRef.close(this.dialogData.control);
  }

  onSet() {
    const orderedList: string[] = [];
    this.dialogData.field.template?.forEach((data: any) => {
      if (this.dialogData.fg.get(this.dialogData.field.name).value?.includes(data.enumValue)) {
        orderedList.push(data.enumValue);
      }
    });
    this.pathControlValue(orderedList);
  }

  openConfirm(event: any, action: string, index: number) {
    event.preventDefault();
    if (action == 'delete') {
      const config: ConfirmDialogConfig<unknown> = {
        secondaryButtonLabel: 'No',
        warnButtonLabel: 'Yes, Delete',
        description: 'Do you want to delete the content?',
        title: 'Delete Content',
      };
      const dialogRef = this._matDialog.open<ConfirmDialogComponent, ConfirmDialogConfig<unknown>>(
        ConfirmDialogComponent,
        {
          width: '420px',
          data: config,
        }
      );
      dialogRef.componentInstance.action.subscribe((data: boolean) => {
        if (data) {
          this.onDelete(index);
        }
      });
    }
  }
}
